import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { passthroughSearch } from '@/router/search';
import InstitutionStorage from '@/ui/pages/InstitutionStorage/InstitutionStorage';

/**
 * HS-1508. The users table keeps its page, search and sort in the URL through the bespoke list
 * hooks (`useListPageParam`, `useListSearch`, `useListSort`), which read the search loosely — the
 * same arrangement as `logs.tsx` and `rfid-tags.index.tsx`.
 */
export const Route = createFileRoute('/_dashboard/institutions/$id/storage')({
  validateSearch: passthroughSearch,
  beforeLoad: requireRoute('/institutions/$id/storage'),
  component: InstitutionStorage,
});
